import { posReportingResources } from "./posReporting";

// Reviewed static display labels. Persisted evidence and user-entered notes are never rewritten.
const groups = {
  entity: `
catalog|Catalog|Katalog|Katalog
customer_document_layout|Customer document layout|Kundendokumentlayout|Układ dokumentów klienta
article|Article|Artikel|Artykuł
product|Product|Produkt|Produkt
product_group|Product group|Produktgruppe|Grupa produktów
modifier|Modifier|Zusatzoption|Modyfikator
modifier_group|Modifier group|Zusatzoptionsgruppe|Grupa modyfikatorów
tax_rule|Tax rule|Steuerregel|Reguła podatkowa
outlet|Outlet|Verkaufsbereich|Punkt sprzedaży
register|Register|Kasse|Kasa
shift|Shift|Schicht|Zmiana
shift_approval|Shift approval|Schichtfreigabe|Zatwierdzenie zmiany
cash_movement|Cash movement|Kassenbewegung|Operacja kasowa
check|Check|Bon|Rachunek
line|Check line|Bonposition|Pozycja rachunku
check_line|Check line|Bonposition|Pozycja rachunku
course|Course|Gang|Etap podania
bill|Bill|Rechnung|Dokument sprzedaży
payment|Payment|Zahlung|Płatność
payment_method|Payment method|Zahlungsart|Metoda płatności
room_charge|Room charge|Zimmerbelastung|Obciążenie pokoju
business_date|Business date|Geschäftstag|Dzień hotelowy
currency|Currency|Währung|Waluta
production|Production|Produktion|Produkcja
production_ticket|Production ticket|Küchenbon|Bon produkcyjny
production_station|Production station|Produktionsstation|Stanowisko produkcyjne
table|Table|Tisch|Stolik
dining_area|Dining area|Gastraum|Sala
table_reservation|Table reservation|Tischreservierung|Rezerwacja stolika
waiter_section|Waiter section|Servicebereich|Rewir kelnerski
user_roles|User roles|Benutzerrollen|Role użytkowników
user_role|User role|Benutzerrolle|Rola użytkownika
permission|Permission|Berechtigung|Uprawnienie
price_list|Price list|Preisliste|Cennik
ingredient|Ingredient|Zutat|Składnik
voucher|Voucher|Gutschein|Bon
gift_card|Gift card|Geschenkkarte|Karta podarunkowa
coupon|Coupon|Coupon|Kupon
promotion|Promotion|Aktion|Promocja
loyalty|Loyalty|Treueprogramm|Program lojalnościowy
loyalty_member|Loyalty member|Treueprogramm-Mitglied|Uczestnik programu lojalnościowego
employee_discount|Employee discount|Mitarbeiterrabatt|Rabat pracowniczy
employee_discount_policy|Employee discount policy|Mitarbeiterrabattregel|Zasada rabatu pracowniczego
house_account|House account|Hauskonto|Konto wewnętrzne
receipt|Receipt|Kassenbeleg|Paragon
receipt_number_series|Receipt number series|Belegnummernkreis|Seria numeracji paragonów
receipt_printer|Receipt printer|Belegdrucker|Drukarka paragonów
payment_terminal|Payment terminal|Zahlungsterminal|Terminal płatniczy
cash_drawer|Cash drawer|Kassenschublade|Szuflada kasowa
kds_device|Kitchen display|Küchendisplay|Ekran kuchenny
tablet|Tablet|Tablet|Tablet
monitoring|Monitoring|Überwachung|Monitorowanie
device_monitoring|Device monitoring|Geräteüberwachung|Monitorowanie urządzeń
device_discovery|Device discovery|Gerätesuche|Wykrywanie urządzeń
advanced_analytics|Advanced analytics|Erweiterte Analysen|Zaawansowana analityka
custom_report_definition|Custom report definition|Eigene Berichtsdefinition|Definicja raportu własnego
custom_report_run|Custom report run|Eigener Berichtslauf|Przebieg raportu własnego
executive_report|Executive report|Managementbericht|Raport zarządczy
report_forecast|Report forecast|Berichtsprognose|Prognoza raportowa
kds_forecast|Kitchen forecast|Küchenprognose|Prognoza kuchenna
payment_reconciliation|Payment reconciliation|Zahlungsabgleich|Uzgadnianie płatności
invoice_email|Invoice email|Rechnungs-E-Mail|Wiadomość z fakturą
company_invoice|Company invoice|Firmenrechnung|Faktura firmowa
consolidated_invoice|Consolidated invoice|Sammelrechnung|Faktura zbiorcza
credit_note|Credit note|Gutschrift|Korekta
proforma_bill|Pro-forma|Proforma|Pro forma
interim_bill|Interim bill|Zwischenrechnung|Rachunek wstępny
void|Void|Storno|Anulowanie
menu|Menu|Speisekarte|Menu
event_menu|Event menu|Veranstaltungsmenü|Menu wydarzenia
`,
  operation: `
activated|Activation|Aktivierung|Aktywacja
deactivated|Deactivation|Deaktivierung|Dezaktywacja
sound_settings.updated|Sound settings update|Änderung der Toneinstellungen|Zmiana ustawień dźwięku
z_report_issued|Z report issued|Z-Bericht erstellt|Wystawienie raportu Z
label_corrected|Label correction|Bezeichnung korrigiert|Korekta nazwy
created|Creation|Erstellung|Utworzenie
updated|Update|Aktualisierung|Aktualizacja
deleted|Deletion|Löschung|Usunięcie
removed|Removal|Entfernung|Usunięcie
opened|Opening|Öffnung|Otwarcie
closed|Closing|Abschluss|Zamknięcie
posted|Posting|Buchung|Księgowanie
failed|Failure|Fehler|Niepowodzenie
reversed|Reversal|Stornierung|Cofnięcie
voided|Void|Storno|Anulowanie
reopened|Reopening|Wiedereröffnung|Ponowne otwarcie
discounted|Discount|Rabattgewährung|Nadanie rabatu
quantity_changed|Quantity change|Mengenänderung|Zmiana ilości
details_changed|Details change|Detailänderung|Zmiana szczegółów
price_overridden|Price override|Preisüberschreibung|Zmiana ceny
production_quantity_corrected|Production quantity correction|Produktionsmengenkorrektur|Korekta ilości produkcyjnej
added|Addition|Hinzufügung|Dodanie
renamed|Renaming|Umbenennung|Zmiana nazwy
transferred|Transfer|Übertragung|Przeniesienie
parked|Parking|Parken|Wstrzymanie
resumed|Resuming|Fortsetzung|Wznowienie
finalized|Finalization|Finalisierung|Finalizacja
generated|Generation|Erstellung|Generowanie
completed|Completion|Abschluss|Zakończenie
printed|Printing|Druck|Drukowanie
issued|Issue|Ausstellung|Wystawienie
queued|Queuing|Einreihung|Dodanie do kolejki
sent|Sending|Versand|Wysłanie
setting_updated|Settings update|Einstellungsänderung|Zmiana ustawień
assigned|Assignment|Zuweisung|Przypisanie
authority_migrated|Authority migration|Berechtigungsübernahme|Migracja uprawnień
approved|Approval|Freigabe|Zatwierdzenie
approval_requested|Approval request|Freigabeanfrage|Wniosek o zatwierdzenie
carried_forward|Carry-forward|Übertrag|Przeniesienie na kolejny dzień
z_report_saved|Z report saved|Z-Bericht gespeichert|Zapis raportu Z
tablet_cash_operation|Tablet cash operation|Kassenvorgang am Tablet|Operacja kasowa na tablecie
tablet_handover|Tablet handover|Übergabe am Tablet|Przekazanie na tablecie
rolled_over|Business-day rollover|Geschäftstagswechsel|Zmiana dnia hotelowego
property_updated|Property currency change|Änderung der Hotelwährung|Zmiana waluty hotelu
configuration.updated|Configuration update|Konfigurationsänderung|Zmiana konfiguracji
evaluated|Health evaluation|Zustandsprüfung|Ocena stanu
send_all|Send all items|Alle Positionen senden|Wysłanie wszystkich pozycji
fired|Send to production|An Produktion senden|Wysłanie do produkcji
fire|Send to production|An Produktion senden|Wysłanie do produkcji
ready|Mark ready|Als fertig markieren|Oznaczenie jako gotowe
served|Mark served|Als serviert markieren|Oznaczenie jako podane
hold|Hold|Zurückstellen|Wstrzymanie
held|Hold|Zurückstellen|Wstrzymanie
automatic_sequence.updated|Automatic sequence update|Änderung der automatischen Gangfolge|Zmiana automatycznej kolejności podania
automatic_sequence.fire_next|Send next course automatically|Nächsten Gang automatisch senden|Automatyczne wysłanie następnego etapu
reprinted|Reprint|Nachdruck|Ponowny wydruk
reprint_failed|Reprint failure|Nachdruckfehler|Błąd ponownego wydruku
print_failed|Print failure|Druckfehler|Błąd wydruku
priority.updated|Priority change|Prioritätsänderung|Zmiana priorytetu
block_changed|Room-charge block change|Änderung der Zimmerbelastungssperre|Zmiana blokady obciążania pokoju
reopened_after_payment_reversal|Reopening after payment reversal|Wiedereröffnung nach Zahlungsstorno|Ponowne otwarcie po cofnięciu płatności
reopened_after_room_charge_reversal|Reopening after room charge reversal|Wiedereröffnung nach Storno der Zimmerbelastung|Ponowne otwarcie po cofnięciu obciążenia pokoju
bill_requested|Bill request|Rechnungsanforderung|Żądanie rachunku
bill_request_cleared|Bill request cleared|Rechnungsanforderung aufgehoben|Usunięcie żądania rachunku
discount_recalculated|Discount recalculation|Rabattneuberechnung|Przeliczenie rabatu
guest_count_changed|Guest count change|Änderung der Gästezahl|Zmiana liczby gości
opening_details_set|Opening details recorded|Eröffnungsdaten erfasst|Zapis szczegółów otwarcia
lines_transferred_in|Items transferred in|Positionen übernommen|Przeniesienie pozycji na rachunek
lines_transferred_out|Items transferred out|Positionen abgegeben|Przeniesienie pozycji z rachunku
split_created|Split check created|Teilbon erstellt|Utworzenie oddzielonego rachunku
split_out|Check split|Bon aufgeteilt|Podział rachunku
quantity_split_created|Split quantity created|Teilmengenposition erstellt|Utworzenie oddzielonej ilości
quantity_split_out|Quantity split|Menge aufgeteilt|Podział ilości
table_merged|Table merge|Tischzusammenlegung|Połączenie stolików
table_moved|Table move|Tischwechsel|Zmiana stolika
transferred_seats_set|Transferred seats recorded|Übertragene Plätze erfasst|Zapis przeniesionych miejsc
waiter_assigned|Waiter assignment|Servicekraftzuweisung|Przypisanie kelnera
layout_updated|Layout update|Planänderung|Zmiana układu
merged|Merge|Zusammenlegung|Połączenie
merge_received|Merge received|Zusammenlegung übernommen|Przyjęcie połączenia
merge_released|Merge released|Zusammenlegung aufgehoben|Zwolnienie połączenia
separated|Separation|Trennung|Rozdzielenie
service_status_changed|Service status change|Änderung des Servicestatus|Zmiana statusu obsługi
arrived|Arrival|Ankunft|Przybycie
cancelled|Cancellation|Stornierung|Anulowanie
seated|Seating|Platzierung|Usadzenie gości
device_connection_checked|Device connection check|Geräteverbindungsprüfung|Sprawdzenie połączenia urządzenia
document_correction.approved|Document correction approval|Freigabe der Dokumentkorrektur|Zatwierdzenie korekty dokumentu
house_account.approved|House account approval|Hauskontofreigabe|Zatwierdzenie konta wewnętrznego
operation.approved|Operation approval|Vorgangsfreigabe|Zatwierdzenie operacji
command_completed|Command completion|Befehlsabschluss|Zakończenie polecenia
reconciliation_required|Reconciliation required|Abgleich erforderlich|Wymagane uzgodnienie
sale_uncertain|Uncertain sale result|Unklarer Verkaufsausgang|Niepewny wynik sprzedaży
availability.cleared|Availability override cleared|Verfügbarkeitsüberschreibung aufgehoben|Usunięcie nadpisania dostępności
availability.updated|Availability change|Verfügbarkeitsänderung|Zmiana dostępności
barcodes.updated|Barcode change|Barcodeänderung|Zmiana kodów kreskowych
duplicated|Duplication|Duplizierung|Duplikowanie
image.removed|Image removal|Bildentfernung|Usunięcie zdjęcia
image.updated|Image update|Bildänderung|Zmiana zdjęcia
outlet_prices.updated|Outlet price change|Änderung der Verkaufspreise|Zmiana cen punktu sprzedaży
outlet_sold_out.updated|Outlet sold-out status change|Änderung des Ausverkauft-Status|Zmiana statusu wyprzedania w punkcie
recipe.removed|Recipe removal|Rezeptentfernung|Usunięcie receptury
recipe.updated|Recipe update|Rezeptänderung|Zmiana receptury
translations.updated|Translation update|Übersetzungsänderung|Zmiana tłumaczeń
redeemed|Redemption|Einlösung|Wykorzystanie
redemption_reversed|Redemption reversal|Rücknahme der Einlösung|Cofnięcie wykorzystania
approval_policy.updated|Approval policy update|Änderung der Freigaberegel|Zmiana zasad zatwierdzania
`,
  field: `
priceMinor|Price|Preis|Cena
taxRuleId|Tax rule|Steuerregel|Reguła podatkowa
taxRateBasisPoints|Tax rate|Steuersatz|Stawka podatku
priceIncludesTax|Tax included|Steuer enthalten|Podatek w cenie
name|Name|Name|Nazwa
displayName|Display name|Anzeigename|Nazwa wyświetlana
code|Code|Code|Kod
status|Status|Status|Status
enabled|Enabled|Aktiviert|Włączone
description|Description|Beschreibung|Opis
quantity|Quantity|Menge|Ilość
discountMinor|Discount|Rabatt|Rabat
discountPercent|Discount percentage|Rabattsatz|Procent rabatu
reason|Reason|Grund|Powód
note|Note|Notiz|Notatka
notes|Notes|Notizen|Notatki
currency|Currency|Währung|Waluta
amountMinor|Amount|Betrag|Kwota
totalMinor|Total|Gesamtbetrag|Suma
tipMinor|Tip|Trinkgeld|Napiwek
paymentMethodId|Payment method|Zahlungsart|Metoda płatności
openingFloatMinor|Opening float|Anfangsbestand|Stan początkowy
expectedClosingMinor|Expected closing|Soll-Endbestand|Oczekiwany stan zamknięcia
actualClosingMinor|Counted closing|Gezählter Endbestand|Przeliczony stan zamknięcia
varianceMinor|Variance|Differenz|Różnica
differenceNote|Difference note|Differenznotiz|Notatka do różnicy
businessDate|Business date|Geschäftstag|Dzień hotelowy
outletId|Outlet|Verkaufsbereich|Punkt sprzedaży
outletIds|Outlets|Verkaufsbereiche|Punkty sprzedaży
registerId|Register|Kasse|Kasa
shiftId|Shift|Schicht|Zmiana
tableId|Table|Tisch|Stolik
guestCount|Guest count|Gästezahl|Liczba gości
assignedWaiterUserId|Assigned waiter|Zugewiesene Servicekraft|Przypisany kelner
assignedWaiterUserName|Waiter name|Name der Servicekraft|Nazwisko kelnera
sortOrder|Display order|Anzeigereihenfolge|Kolejność wyświetlania
productGroupId|Product group|Produktgruppe|Grupa produktów
productionStationId|Production station|Produktionsstation|Stanowisko produkcyjne
courseCode|Course|Gang|Etap podania
priority|Priority|Priorität|Priorytet
roles|Roles|Rollen|Role
permissions|Permissions|Berechtigungen|Uprawnienia
capabilities|Capabilities|Befugnisse|Uprawnienia funkcjonalne
ownerName|Owner name|Verantwortlicher|Osoba odpowiedzialna
ownerContact|Owner contact|Kontakt des Verantwortlichen|Kontakt do osoby odpowiedzialnej
checkIntervalMinutes|Check interval|Prüfintervall|Interwał kontroli
responseThresholdMinutes|Response threshold|Reaktionsfrist|Limit czasu reakcji
staleAfterMinutes|Stale threshold|Veraltungsgrenze|Limit aktualności
consecutiveFailureThreshold|Failure threshold|Fehlerschwelle|Próg błędów
connectionTimeoutMs|Connection timeout|Verbindungszeitlimit|Limit czasu połączenia
version|Version|Version|Wersja
`,
  code: `
catalog|Catalog|Katalog|Katalog
operations|Operations|Vorgänge|Operacje
critical|Critical|Kritisch|Krytyczne
info|Information|Information|Informacyjne
debug|Debug|Diagnose|Diagnostyczne
stale|Stale|Veraltet|Nieaktualne
degraded|Degraded|Beeinträchtigt|Obniżona sprawność
delivered|Delivered|Zugestellt|Dostarczone
not_configured|Not configured|Nicht eingerichtet|Nieskonfigurowane
skipped|Skipped|Übersprungen|Pominięte
combined|Health and login|Zustand und Anmeldung|Stan i logowanie
health|Health check|Zustandsprüfung|Kontrola stanu
login|Login check|Anmeldeprüfung|Kontrola logowania
synthetic_login|Synthetic login|Testanmeldung|Logowanie testowe
application|Application|Anwendung|Aplikacja
client|Browser|Browser|Przeglądarka
server|Server|Server|Serwer
synthetic|Synthetic test|Synthetischer Test|Test syntetyczny
operational_drill|Operational drill|Betriebstest|Test operacyjny
runtime_error|Runtime error|Laufzeitfehler|Błąd działania
unhandled_rejection|Unhandled rejection|Unbehandelte Ablehnung|Nieobsłużone odrzucenie
tcp_connect|TCP connection|TCP-Verbindung|Połączenie TCP
heartbeat|Heartbeat|Lebenszeichen|Sygnał aktywności
persisted_command_status|Saved command status|Gespeicherter Befehlsstatus|Zapisany status polecenia
receipt_printer|Receipt printer|Belegdrucker|Drukarka paragonów
kitchen_printer|Kitchen printer|Küchendrucker|Drukarka kuchenna
payment_terminal|Payment terminal|Zahlungsterminal|Terminal płatniczy
kds_device|Kitchen display|Küchendisplay|Ekran kuchenny
cash_drawer|Cash drawer|Kassenschublade|Szuflada kasowa
`,
};
const copy: ReadonlyArray<readonly [string, string, string]> = [
  ["Catalog setup", "Katalogeinrichtung", "Konfiguracja katalogu"],
  ["Automatic payment reconciliation", "Automatischer Zahlungsabgleich", "Automatyczne uzgadnianie płatności"],
  ["Xentros POS production health/login monitor failed", "Xentros POS: Betriebszustands-/Anmeldeüberwachung fehlgeschlagen", "Xentros POS: błąd monitorowania stanu produkcji i logowania"],
  ["Synthetic POS error used to prove centralized logging, alert correlation and acknowledgement.", "Synthetischer POS-Fehler zum Nachweis zentraler Protokollierung, Alarmverknüpfung und Bestätigung.", "Syntetyczny błąd POS do weryfikacji centralnego rejestrowania, powiązania alertów i potwierdzania."],
  ["Device monitoring request failed.", "Geräteüberwachungsanfrage fehlgeschlagen.", "Żądanie monitorowania urządzeń nie powiodło się."],
  ["Saved device monitoring could not be loaded.", "Gespeicherte Geräteüberwachung konnte nicht geladen werden.", "Nie udało się wczytać zapisanych danych monitorowania urządzeń."],
  ["Device monitoring configuration could not be saved.", "Geräteüberwachungskonfiguration konnte nicht gespeichert werden.", "Nie udało się zapisać konfiguracji monitorowania urządzeń."],
  ["Device health evaluation failed.", "Gerätezustandsprüfung fehlgeschlagen.", "Ocena stanu urządzeń nie powiodła się."],
  ["POS monitoring could not be loaded.", "POS-Überwachung konnte nicht geladen werden.", "Nie udało się wczytać monitorowania POS."],
  ["POS error events could not be loaded.", "POS-Fehlerereignisse konnten nicht geladen werden.", "Nie udało się wczytać zdarzeń błędów POS."],
  ["{{entity}} — {{operation}}", "{{entity}} — {{operation}}", "{{entity}} — {{operation}}"],
  ["{{date}} · degraded: {{degraded}}/{{total}}", "{{date}} · beeinträchtigt: {{degraded}}/{{total}}", "{{date}} · obniżona sprawność: {{degraded}}/{{total}}"],
  ["POS {{source}} error: {{code}}", "POS-Fehler ({{source}}): {{code}}", "Błąd POS ({{source}}): {{code}}"],
  ["Xentros POS monitoring test", "Xentros POS-Überwachungstest", "Test monitorowania Xentros POS"],
  ["Test alert for production health and synthetic login monitoring.", "Testalarm zur Betriebszustands- und Testanmeldungsüberwachung.", "Alert testowy monitorowania stanu produkcji i logowania testowego."],
  ["Device monitoring is inactive with the configuration.", "Die Geräteüberwachung ist laut Konfiguration inaktiv.", "Monitorowanie urządzenia jest wyłączone w konfiguracji."],
  ["TCP endpoint is reachable; physical device output is not verified.", "TCP-Endpunkt ist erreichbar; die physische Geräteausgabe wurde nicht geprüft.", "Punkt TCP jest osiągalny; fizycznego działania urządzenia nie zweryfikowano."],
  ["TCP endpoint did not accept a connection within the configured timeout.", "Der TCP-Endpunkt hat innerhalb des eingestellten Zeitlimits keine Verbindung angenommen.", "Punkt TCP nie przyjął połączenia w ustawionym limicie czasu."],
  ["KDS heartbeat is current.", "Das KDS-Lebenszeichen ist aktuell.", "Sygnał aktywności KDS jest aktualny."],
  ["KDS heartbeat exceeded its configured timeout.", "Das KDS-Lebenszeichen hat das eingestellte Zeitlimit überschritten.", "Sygnał aktywności KDS przekroczył ustawiony limit czasu."],
  ["KDS has not reported a heartbeat.", "KDS hat kein Lebenszeichen gemeldet.", "KDS nie zgłosił sygnału aktywności."],
  ["The last successful drawer command is older than the configured stale threshold.", "Der letzte erfolgreiche Schubladenbefehl ist älter als die eingestellte Veraltungsgrenze.", "Ostatnie udane polecenie szuflady przekroczyło ustawiony limit aktualności."],
  ["Persisted drawer command status is healthy.", "Der gespeicherte Schubladenbefehlsstatus ist fehlerfrei.", "Zapisany status polecenia szuflady jest prawidłowy."],
  ["No recent successful drawer command is available.", "Kein aktueller erfolgreicher Schubladenbefehl verfügbar.", "Brak niedawnego udanego polecenia szuflady."],
  ["Audit Log is unavailable.", "Audit-Protokoll ist nicht verfügbar.", "Dziennik audytu jest niedostępny."],
  ["The audit response was incomplete.", "Die Audit-Antwort war unvollständig.", "Odpowiedź audytu była niekompletna."],
  ["POS audit request failed ({{status}}).", "POS-Audit-Anfrage fehlgeschlagen ({{status}}).", "Żądanie audytu POS nie powiodło się ({{status}})."],
  ["Monitoring evidence could not be loaded.", "Überwachungsnachweise konnten nicht geladen werden.", "Nie udało się wczytać danych monitorowania."],
];
const entries = [...Object.entries(groups).flatMap(([group, rows]) => rows.trim().split("\n").map(row => {
  const [code, en, de, pl] = row.split("|"); return [`${group}.${code}`, en, de, pl];
})), ...copy.map(([en, de, pl]) => [en, en, de, pl])];
export const posAuditResources = {
  en: { ...posReportingResources.en, ...Object.fromEntries(entries.map(([key, en]) => [key, en])) },
  de: { ...posReportingResources.de, ...Object.fromEntries(entries.map(([key, , de]) => [key, de])) },
  pl: { ...posReportingResources.pl, ...Object.fromEntries(entries.map(([key, , , pl]) => [key, pl])) },
};
